import { QuestionCircleFilled } from "@ant-design/icons";
import styled from "styled-components";

export const Text = styled.h5`
  font-size: 0.875rem;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
  margin-bottom: 0;
  flex-grow: 1;
`;

export const GrayText = styled.h5`
  font-size: 0.75rem;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
  color: #595959;
`;

export const QuestionMark = styled(QuestionCircleFilled)`
  padding-right: 5px;
`;